export enum TypeSalesFlow {
  'actual'= 'actual',
  'nuevo'= 'nuevo',
  'online'= 'online',
  'experanza'= 'experanza'
}
